import { font, colors, devices } from '../../config/theme'
import { widthHeight100 } from '../../utils/jss-utils'

const style = {}

style.base = {
  height: '100%',
  '&::-webkit-scrollbar': {
    display: 'none !important'
  },
  '& form': {
    height: '100%',
    '& .inputTitle': {
      fontSize: '16px !important',
      marginBottom: '20px !important'
    },
    '& button': {
      height: '55px !important',
      fontSize: '16px !important'
    }
  }
}

style.base[devices.desktop] = {
  '& input[type="text"]': {
    fontSize: `${font.sizes.large}`,
    height: '60px !important',
    transition: 'border .3s !important',
    border: `1px solid ${colors.lightGray} !important`,
    borderTop: 'none !important',
    borderLeft: 'none !important',
    borderRight: 'none !important',
    borderRadius: '0px !important',
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    width: '100% !important',
    '&:focus': {
      border: `1px solid ${colors.black} !important`,
      borderTop: 'none !important',
      borderLeft: 'none !important',
      borderRight: 'none !important'
    }
  },
  '& h2': {
    fontWeight: '500 !important'
  },
  '& .footnote': {
    marginTop: '5px !important',
    marginBottom: '25px !important',
    color: '#959595 !important'
  },
  overflowX: 'hidden',
  padding: '5px',
  '& .inputTitle': {
    marginTop: '8px !important'
  },
  ...widthHeight100,
  '& input': {
    fontSize: '26px !important'
  }
}

style.base[devices.mobile] = {
  '& input[type="text"]': {
    fontSize: `${font.sizes.medium}`,
    height: '45px !important',
    transition: 'border .3s !important',
    border: `1px solid ${colors.lightGray} !important`,
    borderTop: 'none !important',
    borderLeft: 'none !important',
    borderRight: 'none !important',
    borderRadius: '0px !important',
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    width: '100% !important',
    '&:focus': {
      border: `1px solid ${colors.black} !important`,
      borderTop: 'none !important',
      borderLeft: 'none !important',
      borderRight: 'none !important'
    }
  },
  '& .footnote': {
    marginTop: '-14px !important',
    marginBottom: '25px !important',
    fontSize: '16px !important',
    color: '#959595 !important',
    lineHeight: '22px !important'
  },
  '& form': {
    '& > div': {
      paddingBottom: '25px'
    },
    '& h2': {
      fontSize: '18px !important'
    }
  },
  overflowX: 'hidden',
  padding: '5px',
  ...widthHeight100,
  '& input': {
    fontSize: '18px !important'
  }
}

export default style
